import React from 'react';

const NotFound = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1 style={{ fontSize: '48px', marginBottom: '20px' }}>404: Page Not Found</h1>
      <p style={{ fontSize: '24px' }}>Sorry, the page you are looking for does not exist.</p>
    </div>
  );
};

export default NotFound;
